module.exports = __webpack_public_path__ + "static/media/tipsImg1.3645b84f.jpg";